export default class MenuUnavailableModuleModeKind {
  static ACTIVE = 'ACTIVE';
  static HIDDEN = 'HIDDEN';
  static DISABLED = 'DISABLED';
}
